import { create } from 'zustand';

export interface AgentError {
  message: string;
}

interface AgentErrorState {
  current: AgentError | null;
}

const useStore = create<AgentErrorState>(() => ({ current: null }));

/** Turns whatever was thrown into something worth showing a person. */
export function describeAgentError(error: unknown): string {
  const raw = error instanceof Error ? error.message : String(error ?? '');

  if (!raw || /^\s*$/.test(raw)) return 'The assistant could not be reached.';
  if (/failed to fetch|networkerror|load failed/i.test(raw)) {
    return 'Lost connection to the assistant.';
  }
  return raw;
}

export function reportAgentError(error: unknown): void {
  useStore.setState({ current: { message: describeAgentError(error) } });
}

export function clearAgentError(): void {
  if (useStore.getState().current === null) return;
  useStore.setState({ current: null });
}

export function resetAgentErrorStore(): void {
  useStore.setState({ current: null });
}

export function useAgentError(): AgentError | null {
  return useStore((state) => state.current);
}
